const value = Object.freeze({
  Equipment: 1,
  Services: 2,
});
export default value;
